module.exports = __webpack_public_path__ + "images/2d9645fb6f2847394c780499c7f00c53.png";